<div class="ui-fluid ui-g-12 card">

  <!-- Report Company, Applications -->
  <div class="ui-g-12">

    <div class="description ui-g-12">
      {{ 'report.companiesAppReport' | translate }}
      <hr>
    </div>

    <div class="ui-g-12">
        <i class="fa fa-info-circle icon" style="float: right;" pTooltip="{{ 'report.info' | translate }}" tooltipPosition="left" (click)="openDialog('reportCompanyApp')"></i>
    </div>

    <!-- Filtro Visualizza Utenti -->
    <div class="padd ui-g-12">
      <label>{{ 'report.viewUsers' | translate }}</label>
      <br>
      <p-inputSwitch [(ngModel)]="showUsers"></p-inputSwitch>
    </div>

    <!-- Bottone Visualizza Report -->
    <div class="ui-g-12 text-center padd-top">
      <p-button
          styleClass="ui-button-info"
          label="{{ 'report.viewReport' | translate }}"
          (onClick)="reportCompanyApplication()"
          >
        </p-button>
    </div>
  </div>
</div>

<!-- Report -->
<div *ngIf="showReport" class="ui-g-12">
  <app-view-report 
  [showCompanyApp]="showReportCompanyApp" 
  [data]="report">
  </app-view-report>
</div>



// WEBPACK FOOTER //
// ./src/app/views/administration/report-user/report-company-app/report-company-app.component.html